import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import './index.css'
import Home from './pages/Home'
import About from './pages/About'
import reportWebVitals from './reportWebVitals'
import CustomCursor from './components/CustomCursor'
import Navigation from './components/Navigation'
import Header from './components/Header'
import Projects from './pages/Work'
import Contact from './pages/Contact'
import PageTransition from './components/PageTransition'
import { TransitionProvider } from './context/TransitionContext'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Router basename="">
      <TransitionProvider>
        <Navigation />
        <Header />
        <CustomCursor />
        <PageTransition />
        <Routes>
          <Route
            path="/"
            element={<Home />}
          />
          <Route
            path="/about"
            element={<About />}
          />
          <Route
            path="/work"
            element={<Projects />}
          />
          <Route
            path="/contact"
            element={<Contact />}
          />
        </Routes>
      </TransitionProvider>
    </Router>
  </React.StrictMode>
)

reportWebVitals()
